import { GuidedSession } from '../data/guidedSessions';

export interface GuidedFrame {
  index: number;
  phaseElapsedSec: number;
  phaseRemainingSec: number;
  done: boolean;
}

export function phaseDurationsSec(session: GuidedSession): number[] {
  return session.phases.map((p) => p.minutes * 60);
}

export function sessionTotalSec(session: GuidedSession): number {
  return phaseDurationsSec(session).reduce((a, b) => a + b, 0);
}

export function frameAtElapsed(session: GuidedSession, elapsedSec: number): GuidedFrame {
  const durations = phaseDurationsSec(session);
  const total = durations.reduce((a, b) => a + b, 0);
  if (elapsedSec >= total) {
    const last = durations.length - 1;
    return { index: last, phaseElapsedSec: durations[last], phaseRemainingSec: 0, done: true };
  }
  let acc = 0;
  for (let i = 0; i < durations.length; i++) {
    if (elapsedSec < acc + durations[i]) {
      const phaseElapsedSec = elapsedSec - acc;
      return {
        index: i,
        phaseElapsedSec,
        phaseRemainingSec: durations[i] - phaseElapsedSec,
        done: false,
      };
    }
    acc += durations[i];
  }
  // Unreachable (elapsed < total guaranteed), but keep TypeScript happy.
  return { index: 0, phaseElapsedSec: 0, phaseRemainingSec: durations[0] ?? 0, done: false };
}
